/**
 * Flags de BUILD-TIME para el entorno de desarrollo desplegado.
 * Ver environment.ts para la nota de runtime config (endpoints/OIDC via /public/config.json).
 */
export const environment = {
  production: false,
  appVersion: '0.1.0-dev',
} as const;
